<template>
  <div>
    <div class="lineSoneApp"></div>
    <div class="accountset1">
      <div class="content">
        <div class="backList" @click="goNumList">
          <i class="el-icon-arrow-left"></i>
          <span class="verticalLine">|</span>
          <span class="membership">入会会员</span>
        </div>
        <!-- 切换部分 -->
        <div class="hugStyle">
          <div
            style="display: inline-block; margin-right: 32px"
            :style="{ color: topSelect === 1 ? changeColor : '' }"
            @click="hugItemBtn(1)"
          >
            {{ messageNumOne }}
            <div
              class="underlinedFor"
              :style="{
                background: topSelect === 1 ? changeColor : '',
                border: topSelect == 1 ? '1px solid #1F4287' : '1px solid #fff',
              }"
            ></div>
          </div>
          <div
            style="display: inline-block; margin-right: 32px"
            :style="{ color: topSelect === 2 ? changeColor : '' }"
            @click="hugItemBtn(2)"
          >
            {{ messageNumTwo }}
            <div
              class="underlinedFor"
              :style="{
                background: topSelect === 2 ? changeColor : '',
                border: topSelect == 2 ? '1px solid #1F4287' : '1px solid #fff',
              }"
            ></div>
          </div>
          <div
            style="display: inline-block"
            :style="{ color: topSelect === 3 ? changeColor : '' }"
            @click="hugItemBtn(3)"
          >
            {{ messageNumThree }}
            <div
              class="underlinedFor"
              :style="{
                background: topSelect === 3 ? changeColor : '',
                border: topSelect == 3 ? '1px solid #1F4287' : '1px solid #fff',
              }"
              style="margin-left: 21px"
            ></div>
          </div>
        </div>
        <div class="lineHugOne"></div>
        <!-- 会员数据 -->
        <div v-if="topSelect === 1">
          <!-- 会员指标 -->
          <div class="look-content">
            <el-col :span="3">
              <div class="title">会员总量（人）</div>
              <div class="count">{{ dataList.memberSum }}</div>
              <div class="title">
                <span style="float: left">昨日:</span>
                <span
                  ><i
                    :class="
                      tommerNum.memberSum >= 0
                        ? 'el-icon-caret-top iconColor'
                        : 'el-icon-caret-bottom iconColorOne'
                    "
                    style="color: #1f4287; font-size: 20px; vertical-align: top"
                  ></i
                ></span>
                <span
                  :class="
                    tommerNum.memberSum >= 0 ? 'iconColor' : 'iconColorOne'
                  "
                  class="update-num"
                >
                  {{ tommerNum.memberSum >= 0 ? "+" : "-"
                  }}{{ tommerNum.memberSum }}
                </span>
              </div>
            </el-col>
            <el-col :span="3" class="data-item">
              <div class="title">累计入会数（人）</div>
              <div class="count">{{ dataList.joinSum }}</div>
              <div class="title">
                <span style="float: left">昨日:</span>
                <span
                  ><i
                    :class="
                      tommerNum.joinSum >= 0
                        ? 'el-icon-caret-top iconColor'
                        : 'el-icon-caret-bottom iconColorOne'
                    "
                    style="color: #1f4287; font-size: 20px; vertical-align: top"
                  ></i
                ></span>
                <span
                  :class="tommerNum.joinSum >= 0 ? 'iconColor' : 'iconColorOne'"
                  class="update-num"
                >
                  {{ tommerNum.joinSum >= 0 ? "+" : "-"
                  }}{{ tommerNum.joinSum }}
                </span>
              </div>
            </el-col>
            <el-col :span="3" class="data-item">
              <div class="title">累计退会数</div>
              <div class="count">{{ dataList.outSum }}</div>
              <div class="title">
                <span style="float: left">昨日:</span>
                <span
                  ><i
                    :class="
                      tommerNum.outSum >= 0
                        ? 'el-icon-caret-top iconColor'
                        : 'el-icon-caret-bottom iconColorOne'
                    "
                    style="color: #1f4287; font-size: 20px; vertical-align: top"
                  ></i
                ></span>
                <span
                  :class="tommerNum.outSum >= 0 ? 'iconColor' : 'iconColorOne'"
                  class="update-num"
                >
                  {{ tommerNum.outSum >= 0 ? "+" : "-" }}{{ tommerNum.outSum }}
                </span>
              </div>
            </el-col>
            <el-col :span="3" class="data-item">
              <div class="title">积分总量</div>
              <div class="count">{{ dataList.scorecradSum }}</div>
              <div class="title">
                <span style="float: left">昨日:</span>
                <span
                  ><i
                    :class="
                      tommerNum.scorecradSum >= 0
                        ? 'el-icon-caret-top iconColor'
                        : 'el-icon-caret-bottom iconColorOne'
                    "
                    style="color: #1f4287; font-size: 20px; vertical-align: top"
                  ></i
                ></span>
                <span
                  :class="
                    tommerNum.scorecradSum >= 0 ? 'iconColor' : 'iconColorOne'
                  "
                  class="update-num"
                >
                  {{ tommerNum.scorecradSum >= 0 ? "+" : "-"
                  }}{{ tommerNum.scorecradSum }}
                </span>
              </div>
            </el-col>
            <el-col :span="3" class="data-item">
              <div class="title">累计发放积分</div>
              <div class="count">{{ dataList.scorecradInSum }}</div>
              <div class="title">
                <span style="float: left">昨日:</span>
                <span
                  ><i
                    :class="
                      tommerNum.scorecradInSum >= 0
                        ? 'el-icon-caret-top iconColor'
                        : 'el-icon-caret-bottom iconColorOne'
                    "
                    style="color: #1f4287; font-size: 20px; vertical-align: top"
                  ></i
                ></span>
                <span
                  :class="
                    tommerNum.scorecradInSum >= 0 ? 'iconColor' : 'iconColorOne'
                  "
                  class="update-num"
                >
                  {{ tommerNum.scorecradInSum >= 0 ? "+" : "-"
                  }}{{ tommerNum.scorecradInSum }}
                </span>
              </div>
            </el-col>
            <el-col :span="3" class="data-item">
              <div class="title">累计消耗积分</div>
              <div class="count">{{ dataList.scorecradOutSum }}</div>
              <div class="title">
                <span style="float: left">昨日:</span>
                <span
                  ><i
                    :class="
                      tommerNum.scorecradOutSum >= 0
                        ? 'el-icon-caret-top iconColor'
                        : 'el-icon-caret-bottom iconColorOne'
                    "
                    style="color: #1f4287; font-size: 20px; vertical-align: top"
                  ></i
                ></span>
                <span
                  :class="
                    tommerNum.scorecradOutSum >= 0
                      ? 'iconColor'
                      : 'iconColorOne'
                  "
                  class="update-num"
                >
                  {{ tommerNum.scorecradOutSum >= 0 ? "+" : "-"
                  }}{{ tommerNum.scorecradOutSum }}
                </span>
              </div>
            </el-col>
            <el-col :span="3" class="data-item">
              <div class="title" style="width: 130px">近30天内将过期积分</div>
              <div class="count">{{ dataList.scorecradInvalidSum }}</div>
            </el-col>
          </div>
          <div class="line" style="top: 5px"></div>
          <!-- 查询条件 -->
          <div style="margin-top: 50px; margin-bottom: 20px">
            <el-form>
              <el-form-item>
                <div class="time-wrap">
                  <span
                    @click="timeChange(7)"
                    :class="{ select_date: queryForm.evaluateTime === '7' }"
                    :style="{
                      color: queryForm.evaluateTime === '7' ? changeColor : '',
                      'border-color':
                        queryForm.evaluateTime === '7' ? changeColor : '',
                    }"
                    class="source_data_item"
                    >近7天</span
                  >
                  <span
                    @click="timeChange(30)"
                    :class="{ select_date: queryForm.evaluateTime === '30' }"
                    :style="{
                      color: queryForm.evaluateTime === '30' ? changeColor : '',
                      'border-color':
                        queryForm.evaluateTime === '30' ? changeColor : '',
                    }"
                    class="source_data_item"
                    >近30天</span
                  >
                  <span
                    @click="timeChange(0)"
                    :class="{ select_date: queryForm.evaluateTime === '0' }"
                    :style="{
                      color: queryForm.evaluateTime === '0' ? changeColor : '',
                      'border-color':
                        queryForm.evaluateTime === '0' ? changeColor : '',
                    }"
                    class="source_data_item"
                    >自定义</span
                  >
                </div>
                <!-- <el-radio
                  v-model="queryForm.evaluateTime"
                  @change="timeChange"
                  v-for="item in options.evaluateTimeOpt"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                > -->
                <div class="my_select_time">
                  <div class="flex">
                    <el-date-picker
                      prefix-icon="no_icon"
                      :type="'datetime'"
                      :value-format="'yyyy-MM-dd'"
                      :placeholder="'开始日期'"
                      style="width: 136px; font-size: 12px !important"
                      class="time1"
                      size="small"
                      format="yyyy-MM-dd"
                      v-model="postForm.sendStartTime"
                      :picker-options="pickerOptionsStart"
                      :disabled="queryForm.evaluateTime != 0"
                    ></el-date-picker>
                    <div
                      class="time_to_text"
                      style="color: #666666"
                      :class="{ to_text_disabled: queryForm.evaluateTime != 0 }"
                    >
                      ~
                    </div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      :type="'datetime'"
                      format="yyyy-MM-dd"
                      :value-format="'yyyy-MM-dd'"
                      style="width: 150px; font-size: 12px !important"
                      class="time2"
                      :placeholder="'结束日期'"
                      size="small"
                      v-model="postForm.sendEndTime"
                      :picker-options="pickerOptionsEnd"
                      :disabled="queryForm.evaluateTime != 0"
                    ></el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      @click="clearTime()"
                    ></i>
                    <img
                      src="@/assets/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                </div>
                <el-button
                  type="primary"
                  style="margin-left: 20px"
                  @click="query()"
                  ><span style="marginleft: 4px">查询</span></el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <!-- 图表趋势 -->
          <div
            id="line-chart"
            class="chart-content"
            :style="{ width: '100%', height: '400px' }"
          ></div>
        </div>
        <!-- 入会记录 -->
        <div v-if="topSelect === 2">
          <div class="integralChange publicStyle">
            <div class="item">
              <div class="item-name">会员查询：</div>
              <el-input
                class="long-input"
                style="width: 146px"
                size="small"
                placeholder="请输入"
                v-model="formDataList.buyerNick"
              ></el-input>
            </div>
            <div class="item">
              <div class="item-name">入会时间：</div>
              <date-time
                :startValue="formDataList.minTime"
                :endValue="formDataList.maxTime"
                v-on:update:startValue="formDataList.minTime = $event"
                v-on:update:endValue="formDataList.maxTime = $event"
              >
              </date-time>
            </div>
            <div class="item">
              <div class="item-name">入会渠道：</div>
              <el-select
                style="width: 146px"
                v-model="formDataList.shopId"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in shopIdDate"
                  :label="
                    item.platform == '全部'
                      ? item.platform
                      : '【' + item.platform + '】' + item.shopTitle
                  "
                  :value="item.shopId"
                ></el-option>
              </el-select>
            </div>
            <div class="item" style="margin-right: 0px">
              <div class="item-name" style="margin-right: 0px">渠道标识：</div>
              <el-input
                class="long-input"
                style="width: 146px"
                size="small"
                v-model="formDataList.ident"
                placeholder="请输入"
              ></el-input
              >&nbsp;&nbsp;
              <el-button
                type="primary"
                style="margin-left: 30px"
                @click="seacherResult"
                ><span style="marginleft: 4px">查询</span></el-button
              >
            </div>
          </div>
          <div>
            <el-table
              tooltip-effect="dark"
              :data="tableData"
              :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
              style="width: 100%; border: 1px solid #eee"
            >
              <template slot="empty">
                <div style="margin: 20px">
                  <img
                    src="../../../assets/images/nodata.png"
                    style="
                      display: inline-block;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  <span style="color: #999999" class="nodata">没有数据哦~</span>
                  <!-- <span class="nodata1">暂无数据</span> -->
                </div>
              </template>
              <el-table-column width="20px"></el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="mobile" label="手机号"></el-table-column>
              <el-table-column label="平台昵称">
                <template slot-scope="scope">
                  <span>{{ scope.row.buyerNick }}</span>
                </template>
              </el-table-column>
              <el-table-column label="入会类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.registerType | statusStrOne }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="shopTitle" label="入会渠道">
                <template slot-scope="scope">
                  <span
                    >【{{ scope.row.platform | statusStr }}】{{
                      scope.row.shopTitle
                    }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="ident" label="渠道标识"></el-table-column>
              <el-table-column
                prop="registerTime"
                label="入会时间"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-tooltip placement="top" effect="dark">
                    <span slot="content" v-if="scope.row.extendInfo.sex"
                      >性别：{{ scope.row.extendInfo.sex | statusStr2 }}<br
                    /></span>
                    <span
                      slot="content"
                      v-if="scope.row.extendInfo.babyBirthday"
                      >宝宝生日：{{ scope.row.extendInfo.babyBirthday }}<br
                    /></span>
                    <span slot="content" v-if="scope.row.extendInfo.birthDate"
                      >生日：{{ scope.row.extendInfo.birthDate }}</span
                    >
                    <el-button type="text" style="color: #1f4287"
                      >详情</el-button
                    >
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!-- 表格分页 -->
            <el-pagination
              background
              style="margin-top: 20px; text-align: right"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="formDataList.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              :current-page="formDataList.pageNum"
            ></el-pagination>
          </div>
        </div>
        <!-- 积分变更记录 -->
        <div v-if="topSelect === 3">
          <div class="integralChange publicStyle">
            <div class="item">
              <div class="item-name">会员编号：</div>
              <el-input
                class="long-input"
                size="small"
                placeholder="请输入"
                v-model="tablePost.shopBuyerId"
              ></el-input>
            </div>
            <div class="item">
              <div class="item-name" style="width: 70px; text-align: right">
                姓名：
              </div>
              <el-input
                class="long-input"
                size="small"
                placeholder="请输入"
                v-model="tablePost.buyerNick"
              ></el-input>
            </div>
            <div class="item">
              <div class="item-name" style="width: 70px; text-align: right">
                手机号：
              </div>
              <el-input
                type="number"
                class="long-input"
                placeholder="请输入"
                size="small"
                v-model="tablePost.mobile"
              ></el-input>
            </div>
            <div class="item">
              <div class="item-name">变更积分：</div>
              <input-range
                :startValue="tablePost.minScoresCount"
                :endValue="tablePost.maxScoresCount"
                v-on:update:startValue="tablePost.minScoresCount = $event"
                v-on:update:endValue="tablePost.maxScoresCount = $event"
              ></input-range>
            </div>
            <div class="item">
              <div class="item-name">变更来源：</div>
              <el-select
                style="width: 300px"
                v-model="tablePost.scoresType"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in shopIdDateOne"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <div class="item-name">变更时间：</div>
              <date-time
                :startValue="tablePost.minUpdateTime"
                :endValue="tablePost.maxUpdateTime"
                v-on:update:startValue="tablePost.minUpdateTime = $event"
                v-on:update:endValue="tablePost.maxUpdateTime = $event"
              >
              </date-time>
            </div>
            <div class="item">
              <div class="item-name">变更原因：</div>
              <el-select
                style="width: 300px"
                v-model="tablePost.updateReason"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in shopIdDateTwo"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                type="primary"
                style="margin-left: 80px"
                @click="seacherResult1"
                ><span style="marginleft: 4px">查询</span></el-button
              >
            </div>
          </div>
          <div class="publicStyle bottombase">
            <el-table
              tooltip-effect="dark"
              :data="tableDataOne"
              :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
              style="width: 100%; border: 1px solid #eee"
              empty-text="暂无数据"
            >
              <template slot="empty">
                <div style="margin: 20px">
                  <img
                    src="../../../assets/images/nodata.png"
                    style="
                      display: inline-block;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  <span style="color: #999999" class="nodata">没有数据哦~</span>
                  <!-- <span class="nodata1">暂无数据</span> -->
                </div>
              </template>
              <el-table-column width="20px;"></el-table-column>
              <el-table-column
                prop="shopBuyerId"
                label="会员编号"
              ></el-table-column>
              <el-table-column prop="buyerNick" label="姓名"></el-table-column>
              <el-table-column prop="mobile" label="手机号"></el-table-column>
              <el-table-column
                prop="scoresCount"
                label="变更积分"
              ></el-table-column>
              <el-table-column label="变更来源">
                <template slot-scope="scope">
                  <span>{{ scope.row.scoresType | statusStr1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="变更原因">
                <template slot-scope="scope">
                  <span>{{ scope.row.updateReason | statusStrTwo }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="变更时间"
              ></el-table-column>
            </el-table>
          </div>
          <!-- 表格分页 -->
          <el-pagination
            background
            style="margin-top: 20px; text-align: right"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="tablePost.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNumOne"
            :current-page="tablePost.pageNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  histroyList,
  page,
  pageList,
  pageMember,
} from "@/api/manage/scoreList";
import { mapState } from "vuex";
import dateTime from "@/components/form/date-range";
import inputRange from "@/components/form/input-range";
export default {
  name: "look_card",
  filters: {
    statusStr(status) {
      return { 1: "淘宝", 2: "京东", 3: "有赞" }[status];
    },
    statusStr1(status) {
      return { 0: "赚积分", 1: "花积分", 2: "过期积分", 3: "批量导入积分" }[
        status
      ];
    },
    statusStr2(status) {
      return { 0: "未知", 1: "男", 2: "女" }[status];
    },
    statusStrOne(status) {
      return { 0: "交易前入会", 1: "交易后入会" }[status];
    },
    statusStrTwo(status) {
      return {
        0: "签到有礼",
        1: "浏览有礼",
        2: "每日抢",
        3: "关注有礼",
        4: "邀请开卡",
        5: "邀请关注",
        6: "审核图片",
        7: "完善信息",
        8: "九宫格抽奖",
        9: "大转盘抽奖",
        10: "领卡有礼",
        11: "口令奖励",
        12: "生日有礼",
        13: "积分兑换实物",
        14: "积分兑换激活码",
        15: "手动导入",
        16: "订单奖励积分",
        17: "规则奖励积分",
      }[status];
    },
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  props: {
    dataList: null,
    tommerNum: null,
    seeId: null,
  },
  components: {
    dateTime,
    inputRange,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.sendStartTime) {
            return (
              time.getTime() < new Date(this.postForm.sendStartTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.sendEndTime) {
            return (
              time.getTime() > new Date(this.postForm.sendEndTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsEndOne: {
        disabledDate: (time) => {
          if (this.formDataList.minTime) {
            return (
              time.getTime() < new Date(this.formDataList.minTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStartOne: {
        disabledDate: (time) => {
          if (this.formDataList.maxTime) {
            return (
              time.getTime() > new Date(this.formDataList.maxTime).getTime()
            );
          } else {
          }
        },
      },
      shopIdDate: [],
      shopIdDateOne: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "赚积分",
        },
        {
          value: "1",
          label: "花积分",
        },
        {
          value: "2",
          label: "过期积分",
        },
        {
          value: "3",
          label: "批量导入积分",
        },
      ],
      shopIdDateTwo: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "签到有礼",
        },
        {
          value: "1",
          label: "浏览有礼",
        },
        {
          value: "2",
          label: "每日抢",
        },
        {
          value: "3",
          label: "关注有礼",
        },
        {
          value: "4",
          label: "邀请开卡",
        },
        {
          value: "5",
          label: "邀请关注",
        },
        {
          value: "6",
          label: "审核图片",
        },
        {
          value: "7",
          label: "完善信息",
        },
        {
          value: "8",
          label: "九宫格抽奖",
        },
        {
          value: "9",
          label: "大转盘抽奖",
        },
        {
          value: "10",
          label: "领卡有礼",
        },
        {
          value: "11",
          label: "口令奖励",
        },
        {
          value: "12",
          label: "生日有礼",
        },
        {
          value: "13",
          label: "积分兑换实物",
        },
        {
          value: "14",
          label: "积分兑换激活码",
        },
        {
          value: "15",
          label: "手动导入",
        },
        {
          value: "16",
          label: "订单奖励积分",
        },
        {
          value: "17",
          label: "规则奖励积分",
        },
      ],
      extendInfoData: {},
      formDataList: {
        buyerNick: "",
        shopId: "",
        minTime: "",
        maxTime: "",
        ident: "",
        pageNum: 1,
        pageSize: 10,
      },
      tablePost: {
        //积分变更
        buyerNick: "",
        maxScoresCount: "",
        minScoresCount: "",
        maxUpdateTime: "",
        minUpdateTime: "",
        mobile: "",
        pageNum: 1,
        pageSize: 10,
        scoresType: "",
        shopBuyerId: "", //会员编号
        updateReason: "",
      },
      radio: "1",
      pageInfo: {
        pageSize: "1",
        pageNum: "10",
      },
      tableData: [],
      changeTypeList: [],
      changeTypeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "会员日赠送积分",
        },
        {
          value: 1,
          label: "会员日赠送积分",
        },
        {
          value: 2,
          label: "手动赠送积分",
        },
        {
          value: 3,
          label: "第三方积分来源",
        },
        {
          value: 4,
          label: "积分奖励规则",
        },
      ],
      messageNumOne: "会员数据",
      messageNumTwo: "入会记录",
      messageNumThree: "积分变更记录",
      topSelect: 1,
      collect: {
        returnCustomerCount: "10",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近一个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      queryForm: {
        evaluateTime: "7",
      },
      postForm: {
        sendStartTime: "",
        sendEndTime: "",
      },
      mytime: [],
      zxData: {
        joinSum: [],
        memberSum: [],
        outSum: [],
        recordDate: [],
        scorecradInSum: [],
        scorecradOutSum: [],
        scorecradSum: [],
      },
      totalNum: 0,
      totalNumOne: 0,
      tableDataOne: [], //积分变更记录
    };
  },
  created() {
    let self = this;
    const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
    this.mytime = date;
    this.postForm.sendStartTime = this.mytime[0];
    this.postForm.sendEndTime = this.mytime[1];
  },
  mounted() {
    this.query();
  },
  methods: {
    clearTime() {
      if (this.queryForm.evaluateTime == 0) {
        this.postForm.sendStartTime = "";
        this.postForm.sendEndTime = "";
      } else {
        return;
      }
    },
    timeChange(type) {
      this.queryForm.evaluateTime = type + "";
      let self = this;
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      if (type == 7) {
        this.postForm.sendStartTime = this.mytime[0];
        this.postForm.sendEndTime = this.mytime[1];
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.sendStartTime = this.mytime[0];
        this.postForm.sendEndTime = this.mytime[1];
      } else {
        this.postForm.sendStartTime = "";
        this.postForm.sendEndTime = "";
      }
    },
    // 会员历史数据查询
    query() {
      histroyList({
        cardId: this.seeId,
        minDate: this.postForm.sendStartTime,
        maxDate: this.postForm.sendEndTime,
      })
        .then((res) => {
          this.zxData.joinSum = [];
          this.zxData.memberSum = [];
          this.zxData.outSum = [];
          this.zxData.recordDate = [];
          this.zxData.scorecradInSum = [];
          this.zxData.scorecradOutSum = [];
          this.zxData.scorecradSum = [];
          res.data.forEach((val, index) => {
            this.zxData.joinSum.push(val.joinSum);
            this.zxData.memberSum.push(val.memberSum);
            this.zxData.outSum.push(val.outSum);
            this.zxData.recordDate.push(val.recordDate);
            this.zxData.scorecradInSum.push(val.scorecradInSum);
            this.zxData.scorecradOutSum.push(val.scorecradOutSum);
            this.zxData.scorecradSum.push(val.scorecradSum);
          });
          this.drawLine();
        })
        .catch(() => {});
    },
    //入会记录查询
    seacherResult() {
      this.formDataList.cardId = this.dataList.scoresCardId;
      page(this.formDataList)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.totalNum = res.data.pageInfo.total;
          }
        })
        .catch(() => {});
    },
    //积分变更记录
    seacherResult1() {
      this.tablePost.cardId = this.dataList.scoresCardId;
      pageMember(this.tablePost)
        .then((res) => {
          if (res.code == 200) {
            this.tableDataOne = res.data.dataList;
            this.totalNumOne = res.data.pageInfo.total;
          }
        })
        .catch(() => {});
    },
    //入会记录分页
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.formDataList.pageNum = 1;
      this.seacherResult();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.seacherResult();
    },
    //变更积分分页
    handleSizeChange1(val) {
      this.tablePost.pageSize = val;
      this.tablePost.pageNum = 1;
      this.seacherResult1();
    },
    handleCurrentChange1(val) {
      this.tablePost.pageNum = val;
      this.seacherResult1();
    },
    //点击切换
    hugItemBtn(type) {
      this.topSelect = type;
      if (this.topSelect == 1) {
        this.$nextTick(() => {
          this.drawLine();
        });
      } else if (this.topSelect == 2) {
        pageList({ cardId: this.dataList.scoresCardId }).then((res) => {
          if (res.code == 200) {
            // let app = {
            //   shopId: "",
            //   platform: "全部",
            //   shopTitle:"默认"
            // };
            // res.data.unshift(app);
            this.shopIdDate = res.data;
            var object = [];
            this.shopIdDate.forEach((item, index) => {
              if (this.shopIdDate[index].platform == 1) {
                item.platform = "淘宝";
              } else if (this.shopIdDate[index].platform.platform == 2) {
                item.platform = "京东";
              } else {
                item.platform = "有赞";
              }
              object.push(item);
            });
            this.shopIdDate = object;
          }
        });
        this.seacherResult();
      } else if (this.topSelect == 3) {
        this.seacherResult1();
      }
    },
    //基于Dom绘画的图表
    drawLine() {
      let _this = this;
      _this.$nextTick(() => {
        if (!document.getElementById("line-chart")) {
          return;
        }
      });
      let myChart = this.$echarts.init(
        document.getElementById("line-chart"),
        "light"
      );
      //属性可以用来获取或设置当前窗口的resize事件的事件处理函数
      window.onresize = myChart.resize;
      //绘制图表
      myChart.setOption({
        legend: {
          data: [
            "会员总量",
            "累计入会数",
            "累计退会数",
            "积分总量",
            "累计发放积分",
            "累计消耗积分",
            "近30天内将过期积分",
          ],
          bottom: -5,
          itemGap: 30,
          itemWidth: 10,
          // padding:10,
          textStyle: {
            fontSize: 12,
          }, // 图例文字颜色
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              background: "#6a7985",
            },
          },
        },
        xAxis: {
          name: "日期",
          type: "category",
          data: _this.zxData.recordDate,
          axisLine: {
            lineStyle: {
              color: "#dddddd",
              width: 1, //这里是为了突出显示加上的
            },
            show: true,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#999",
              width: 1, //这里是为了突出显示加上的
            },
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#F3F3F8",
              width: 1,
            },
          },
        },
        series: [
          {
            name: "会员总量",
            data: _this.zxData.memberSum,
            type: "line",
            itemStyle: {
              color: "rgb(72,31,135)",
            },
            lineStyle: {
              normal: {
                width: 0.7,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(72,31,135, .1)" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "white" },
                ]),
              },
            },
            smooth: false,

            symbol: "none",
          },
          {
            name: "累计入会数",
            data: _this.zxData.joinSum,
            type: "line",
            itemStyle: {
              color: "rgb(38,79,135)",
            },
            lineStyle: {
              normal: {
                width: 0.7,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(38,79,135, .1)" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "white" },
                ]),
              },
            },
            smooth: false,
            symbol: "none",
          },
          {
            name: "累计退会数",
            data: _this.zxData.outSum,
            type: "line",
            itemStyle: {
              color: "rgb(31,66,135)",
            },
            lineStyle: {
              normal: {
                width: 0.7,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(31,66,135, .1)" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "white" },
                ]),
              },
            },
            smooth: false,
            symbol: "none",
          },
          {
            name: "积分总量",
            data: _this.zxData.scorecradSum,
            type: "line",
            itemStyle: {
              color: "rgb(31,90,135)",
            },
            lineStyle: {
              normal: {
                width: 0.7,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(31,90,135, .1)" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "white" },
                ]),
              },
            },
            smooth: false,
            symbol: "none",
          },
          {
            name: "累计发放积分",
            data: _this.zxData.scorecradInSum,
            type: "line",
            itemStyle: {
              color: "rgb(31,114,135)",
            },
            lineStyle: {
              normal: {
                width: 0.7,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(31,114,135, .1)" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "white" },
                ]),
              },
            },
            smooth: false,
            symbol: "none",
          },
          {
            name: "累计消耗积分",
            data: _this.zxData.scorecradOutSum,
            type: "line",
            itemStyle: {
              color: "rgb(108,75,159)",
            },
            lineStyle: {
              normal: {
                width: 0.7,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(108,75,159, .1)" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "white" },
                ]),
              },
            },
            smooth: false,
            symbol: "none",
          },
        ],
      });
    },
    //返回列表
    goNumList() {
      this.$emit("transformAnalysis");
    },
  },
};
</script>
<style lang="scss" scope>
.time-wrap {
  display: inline-block;
  margin-right: 10px;
  .select_date {
    color: #1f4287;
    background: #f6f7fa;
    border: 1px solid #7489b5;
  }
  .source_data_item {
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-right: 8px;
    display: inline-block;
    cursor: pointer;
    width: 60px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #bbbbbb;
    border-radius: 6px;
    background: #ffffff;
    box-sizing: border-box;
    text-align: center;
    color: #333333;
    height: 32px;
    line-height: 30px;
    &:hover {
      color: #1f4287;
      background: #f6f7fa;
      border: 1px solid #7489b5;
    }
  }
}
// .lineSoneApp {
//   top: 109px;
//   width: 100%;
//   height: 1px;
//   border-radius: 1px;
//   position: relative;
//   background: rgba(243, 243, 243, 1);
//   opacity: 1;
// }
.lineHugOne {
  height: 1px;
  background: #f3f3f3;
  opacity: 1;
  border-radius: 1px;
}
.accountset1 {
  .content {
    box-sizing: border-box;
    padding: 24px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
    border-radius: 6px;
    .backList {
      width: 200px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
      margin-bottom: 26px;
      cursor: pointer;

      .verticalLine {
        width: 1px;
        height: 18px;
        background: #ffffff;
        opacity: 1;
        margin: 0 20px;
      }
      .membership {
        width: 72px;
        height: 25px;
        font-size: 18px;
        font-weight: bold;
        line-height: 21px;
        color: #333333;
        opacity: 1;
      }
    }
    .hugStyle {
      overflow: hidden;
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      .underlinedFor {
        height: 2px;
        width: 40px;
        margin-left: 8px;
        text-align: center;
        margin-top: 11px;
        opacity: 1;
        cursor: pointer;
        border-radius: 6px;
      }
    }
    .look-content {
      padding-bottom: 80px;
      margin-top: 25px;
      .data-item {
        margin-left: 20px;
        @media screen and(max-width: 1360px) {
          margin-left: 10px;
        }
      }
      .count {
        font-weight: 500;
        line-height: 40px;
        font-size: 18px;
        font-family: DIN;
        font-weight: bold;
        color: #333333;
        opacity: 1;
      }
      .title {
        color: #666666;
        font-size: 14px;
        font-weight: 400;
        opacity: 1;
        .iconColor {
          color: #1f4287 !important;
        }
        .iconColorOne {
          color: #e02020 !important;
        }
        .update-num {
          margin-left: 50px;
          @media screen and(max-width: 1360px) {
            margin-left: 30px;
          }
        }
      }
    }
    .publicStyle {
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      margin-top: 24px;
      margin-bottom: 14px;
    }
    .integralChange {
      .item {
        margin-bottom: 20px;
        display: inline-block;
        vertical-align: middle;
        color: #666;
        font-size: 14px;
        margin-right: 80px;
        .item-name {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          display: inline-block;
        }
        .long-input {
          width: 300px;
          display: inline-block;
        }
      }
    }
    .bottombase {
    }
  }
}
</style>
<style scoped lang="scss">
.my_select_time {
  position: relative;
  display: inline-block;
  border: 1px solid #b7bcc6;
  border-radius: 6px;
  vertical-align: middle;
  overflow: hidden;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  .flex {
    display: flex;
    flex-direction: row;
    align-content: center;
  }

  .time_to_text {
    display: inline-block;
    font-size: 14px;
    padding: 0px !important;

    // height: 33px;
    // line-height: 33px;

    // border-top: 1px solid #b7bcc6;
    color: #666666;
    margin-top: 0px !important;
    // border-bottom: 1px solid #b7bcc6;
    vertical-align: middle;
    text-align: center;
    width: 14px;
  }

  .to_text_disabled {
    background: #f5f7fa;
    cursor: not-allowed;
  }
  .time1 {
    width: 110px;
    /deep/.el-input__inner {
      padding: 0 0px 0 7px !important;
      border: none;
      //  height: 33px;
      //  line-height: 33px;
      border-radius: 0;
      // border-right: 0px;
      // border-radius: 6px;
      // border-top-right-radius: 0px;
      // border-bottom-right-radius: 0px;
    }
  }
  .time2 {
    width: 155px;
    /deep/.el-input__inner {
      border-left: 0px;
      border: none;
      border-radius: 0;
      // height: 33px;
      // line-height: 33px;
      // border-radius: 6px;
      // border-top-left-radius: 0px;
      // border-bottom-left-radius: 0px;
      // padding: 0 20px 0 4px !important;
    }
  }
  .date_icon2,
  .date_icon1 {
    position: absolute;
    right: 5px;
    height: 32px;
    line-height: 32px;
    width: 16px;
    font-size: 16px;
  }
  .date_icon1 {
    display: none;
    cursor: pointer;
  }
}
.my_select_time:hover {
  .date_icon2 {
    display: none;
  }
  .date_icon1 {
    display: inline-block;
  }
}
.to_text_disabled {
  background: #f5f7fa;
  cursor: not-allowed;
  // border-bottom: 1px solid #dcdfe6 !important;
  // border-top: 1px solid #dcdfe6 !important;
}
</style>
